import React from 'react'

export const WarningIcon = () => (
  <svg width="50" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48.787 36.117 29.544 2.868a5.253 5.253 0 0 0-9.089 0v.002L1.212 36.117a5.25 5.25 0 0 0 4.543 7.88h38.49a5.25 5.25 0 0 0 4.542-7.88zm-25.54-18.368a1.75 1.75 0 1 1 3.5 0v8.75a1.75 1.75 0 0 1-3.5 0v-8.75zM25 37a2.624 2.624 0 1 1 0-5.248 2.624 2.624 0 0 1 0 5.248z"
      fill="#FF8B00"
    />
  </svg>
)
